// extracted by mini-css-extract-plugin
module.exports = {"seleziona_data":"PacchettoDettagliTipo1_seleziona_data__2EhYJ","programma_container":"PacchettoDettagliTipo1_programma_container__1jJes"};